import { useNavigate } from "react-router-dom";
import { projects, type Project } from "@/mocks/projects";

interface RelatedProjectsProps {
  currentProject: Project;
}

export default function RelatedProjects({ currentProject }: RelatedProjectsProps) {
  const navigate = useNavigate();

  const related = projects
    .filter(
      (p) =>
        p.id !== currentProject.id &&
        (p.category === currentProject.category || p.client === currentProject.client)
    )
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <span className="text-[#4CAF50] text-xs font-semibold uppercase tracking-widest mb-3 block">
          Benzer Projeler
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A2B4A] mb-8">
          İlgili Projeler
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {related.map((project) => (
            <div
              key={project.id}
              className="bg-[#F8F9FA] rounded-2xl overflow-hidden cursor-pointer group hover:-translate-y-1.5 transition-all duration-300 border border-[#E2E8F0]"
              onClick={() => {
                navigate(`/projeler/${project.id}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 text-xs font-semibold px-2.5 py-1 rounded-full bg-emerald-500/90 text-white">
                  Tamamlandı
                </div>
              </div>
              <div className="p-4">
                <div className="text-xs text-[#4CAF50] font-semibold uppercase tracking-wide mb-1">
                  {project.category}
                </div>
                <h3 className="text-[#1A2B4A] font-bold text-sm leading-snug mb-2">
                  {project.title}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1 text-[#718096] text-xs">
                    <i className="ri-map-pin-line" />
                    {project.location}
                  </div>
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#4CAF50]/10 group-hover:bg-[#4CAF50] transition-colors duration-200">
                    <i className="ri-arrow-right-line text-xs text-[#4CAF50] group-hover:text-white transition-colors duration-200" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
